import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  container: {
    maxWidth: '1220px',
    margin: 'auto',
    padding: { xs: '0 20px', md: '0 32px' },
  },
  narrowContainer: { maxWidth: '900px' },
  section: { padding: { xs: '46px 0', md: '64px 0' }, backgroundColor: '#fff' },
  alternateSection: {
    padding: { xs: '46px 0', md: '64px 0' },
    backgroundColor: '#f5f7fa',
    borderTop: '1px solid #e4e9ef',
    borderBottom: '1px solid #e4e9ef',
  },
  parametersSection: {
    padding: { xs: '38px 0', md: '52px 0' },
    backgroundColor: '#fff',
  },
  parametersCard: {
    border: '1px solid #dce4ea',
    borderRadius: '18px',
    padding: { xs: '22px', md: '30px' },
    boxShadow: '0 10px 30px rgba(15, 23, 42, .06)',
  },
  sectionHeading: {
    display: 'flex',
    gap: '14px',
    alignItems: 'center',
    marginBottom: '22px',
  },
  sectionIcon: {
    width: '46px',
    height: '46px',
    borderRadius: '12px',
    display: 'grid',
    placeItems: 'center',
    color: '#b01f62',
    backgroundColor: '#f9e8f0',
  },
  sectionTitle: {
    color: '#172033',
    fontSize: { xs: '24px', md: '31px' },
    lineHeight: 1.2,
    fontWeight: 800,
    textTransform: 'capitalize',
    marginBottom: '8px',
  },
  sectionSubtitle: {
    color: '#617083',
    fontSize: '15px',
    lineHeight: 1.6,
    marginBottom: '24px',
  },
  parameterGrid: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
    gap: '12px',
  },
  parameterItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '14px',
    borderRadius: '10px',
    backgroundColor: '#f7fafb',
    color: '#334155',
    fontWeight: 600,
    '& svg': { color: '#078277' },
  },
  bundleSection: {
    padding: { xs: '46px 0', md: '64px 0' },
    background: 'linear-gradient(180deg, #fff 0%, #edf7f7 100%)',
    borderTop: '1px solid #e2e8f0',
  },
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
    gap: '20px',
  },
  fourColumnGrid: {
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      sm: 'repeat(2, 1fr)',
      lg: 'repeat(4, 1fr)',
    },
    gap: '18px',
    marginTop: '24px',
  },
  bundleCard: {
    position: 'relative',
    padding: '28px 22px 22px',
    border: '1px solid #dce4ea',
    borderRadius: '16px',
    backgroundColor: '#fff',
    boxShadow: '0 12px 30px rgba(15, 23, 42, .07)',
  },
  badge: {
    display: 'inline-flex',
    padding: '5px 10px',
    borderRadius: '20px',
    color: '#fff',
    backgroundColor: '#b01f62',
    fontSize: '11px',
    fontWeight: 800,
    textTransform: 'uppercase',
  },
  cardTitle: {
    marginTop: '14px',
    color: '#172033',
    fontSize: '20px',
    fontWeight: 800,
  },
  list: {
    margin: '18px 0',
    display: 'grid',
    gap: '8px',
    '& p': { color: '#526174', fontSize: '14px' },
  },
  outlineButton: {
    display: 'inline-flex',
    padding: '10px 16px',
    border: '2px solid #b01f62',
    borderRadius: '9px',
    color: '#b01f62',
    fontSize: '13px',
    fontWeight: 800,
  },
  cityGrid: {
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      sm: 'repeat(2, 1fr)',
      lg: 'repeat(3, 1fr)',
    },
    gap: '14px',
  },
  cityCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '17px',
    borderRadius: '12px',
    border: '1px solid #d9e1e8',
    backgroundColor: '#fff',
    '& > svg': { color: '#078277' },
  },
  activeCityCard: { border: '2px solid #b01f62', backgroundColor: '#fff5f8' },
  cityName: { color: '#172033', fontWeight: 800 },
  cityCopy: { color: '#708094', fontSize: '12px' },
  reviewCard: {
    padding: '24px',
    border: '1px solid #e2e8f0',
    borderRadius: '16px',
    backgroundColor: '#fff',
    boxShadow: '0 8px 24px rgba(15, 23, 42, .06)',
  },
  stars: {
    display: 'flex',
    color: '#f4a51c',
    '& svg': { width: '18px', height: '18px' },
  },
  reviewCopy: { margin: '16px 0', color: '#3f4d5f', lineHeight: 1.65 },
  reviewAuthor: { color: '#172033', fontSize: '13px', fontWeight: 800 },
  faqSection: {
    padding: { xs: '46px 0', md: '64px 0' },
    backgroundColor: '#edf5f8',
    borderTop: '1px solid #d8e7ee',
  },
  faqList: { display: 'grid', gap: '12px', marginTop: '22px' },
  faqItem: {
    border: '1px solid #d8e1e8',
    borderRadius: '12px',
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
  faqButton: {
    width: '100%',
    border: 0,
    padding: '18px',
    background: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    textAlign: 'left',
    cursor: 'pointer',
    '& p': { color: '#172033', fontWeight: 750 },
  },
  faqIcon: { transition: 'transform .2s ease' },
  faqIconOpen: { transform: 'rotate(180deg)' },
  faqAnswer: { padding: '0 18px 18px', color: '#5c6979', lineHeight: 1.65 },
  relatedCard: {
    padding: '22px',
    border: '1px solid #e0e6ec',
    borderRadius: '14px',
    backgroundColor: '#fff',
    '& > svg': { color: '#b01f62', fontSize: '34px' },
    '& a': { color: '#b01f62', fontSize: '13px', fontWeight: 800 },
  },
  articleCard: {
    padding: '20px',
    borderRadius: '14px',
    backgroundColor: '#fff',
    minHeight: '160px',
    '& > svg': { color: '#078277' },
    '& a': { color: '#b01f62', fontSize: '13px', fontWeight: 800 },
  },
  relatedTitle: {
    margin: '13px 0 8px',
    color: '#172033',
    fontSize: '16px',
    fontWeight: 800,
    lineHeight: 1.35,
  },
  relatedCopy: {
    color: '#6b7788',
    fontSize: '13px',
    lineHeight: 1.5,
    marginBottom: '14px',
  },
  relatedTests: {
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      sm: 'repeat(2, 1fr)',
      lg: 'repeat(3, 1fr)',
    },
    gap: '14px',
    marginTop: '22px',
  },
  testCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '11px',
    padding: '17px',
    border: '1px solid #dfe5eb',
    borderRadius: '12px',
    color: '#172033',
    backgroundColor: '#fff',
    '& svg': { color: '#078277' },
    '& p': { fontWeight: 700 },
  },
  finalCta: {
    padding: { xs: '48px 0 100px', md: '58px 0' },
    backgroundColor: '#005f60',
    color: '#fff',
  },
  ctaContent: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { md: 'center' },
    justifyContent: 'space-between',
    gap: '24px',
    '& h2': { fontSize: { xs: '27px', md: '34px' }, fontWeight: 850 },
    '& p': { marginTop: '8px', color: '#d9eeee' },
  },
  ctaButtons: { display: 'flex', flexWrap: 'wrap', gap: '12px' },
  primaryButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '14px 19px',
    borderRadius: '10px',
    color: '#fff',
    backgroundColor: '#b01f62',
    fontWeight: 800,
  },
  secondaryButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 18px',
    border: '2px solid #fff',
    borderRadius: '10px',
    color: '#fff',
    fontWeight: 800,
    textDecoration: 'none',
  },
  mobileActions: {
    display: { xs: 'flex', md: 'none' },
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    height: '72px',
    padding: '10px',
    gap: '8px',
    zIndex: 1300,
    backgroundColor: '#fff',
    boxShadow: '0 -4px 18px rgba(15, 23, 42, .16)',
  },
  mobileBook: {
    height: '52px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '7px',
    borderRadius: '9px',
    color: '#fff',
    backgroundColor: '#b01f62',
    fontWeight: 800,
  },
  mobileCall: {
    width: '50%',
    height: '52px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '7px',
    borderRadius: '9px',
    color: '#fff',
    backgroundColor: '#078277',
    fontWeight: 800,
    textDecoration: 'none',
  },
})

export type StylesClassNames = StylesClasses<typeof styles>
export default styles
